import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=fff8bf50"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=fff8bf50&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports